import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { ViewEngine } from 'app/infrastructure/model/classes/viewEngine.class';
import { Translator } from 'angular-translator';
import { ViewEngineService } from 'app/infrastructure/services/viewengine.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AzureFile } from 'app/infrastructure/model/interfaces/azureFile.Interface';
import { ConfirmacionModalComponent } from 'app/helpers/components/confirmationModal/confirmationModal.component';
import { File64 } from 'app/helpers/components/sxFileImport/file64.interf';
@Component({
    selector: 'sx-view-engine-component-edit',
    templateUrl: './edit.viewengine.component.html',
})
export class ViewEngineEditComponent implements OnInit {
    systemCode: string;
    codviewEngine: string;
    isAvailableJsfile: boolean = true;
    isAvailableTsfile: boolean = true;
    isAvailableZipfile: boolean = true
    supported: string[] = ['.zip', '.ts', '.js'];
    fileJs: File64 = null;
    fileTs: File64 = null;
    fileZip: File64 = null;
    esNuevo: boolean = true;
    files: AzureFile[] = [];
    errorCodigo: string = null;
    mostrarError: boolean = false;
    viewEngine: ViewEngine = {
        codViewEngine: '',
        description: '', 
        state: 'A',
        moduleName: '',
        title: '',
        configuration: null,
        outputs:null,
        inputs: null,
        organizationCategorySelected: {
            idCategory: null,
            organizationCode: null,
          },
          categories: [],
    };
    disableAlias = false;
    viewEngineErrorCode: string;
    isZipFile: boolean = false;

    constructor(private modalService: NgbModal, private viewEngineService: ViewEngineService,
        private router: Router,
        private aRoute: ActivatedRoute,
        private alertService: AlertService,
        private translate: Translator) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {

            this.codviewEngine = params['codviewengine'];
            this.esNuevo = true;
            if (this.codviewEngine !== undefined && this.codviewEngine !== 'nuevo') {
                this.esNuevo = false;
                this.viewEngineService.get(this.codviewEngine).subscribe(view => {
                    this.validateVECode()
                    if (view !== null) {
                        this.viewEngine = view;
                        this.getFiles(this.codviewEngine);
                        this.disableAlias = true;
                    } else
                        this.back();

                });
            } else {
                this.getOrganizations();
            }
        });
    }
    isNuevo(): boolean {
        return this.esNuevo;
    }
    selectedJsFile(imp: File64) {
        this.fileJs = imp;
        this.errorCodigo = null;
    }
    selectedTsFile(imp: File64) {
        this.fileTs = imp;
    }
    selectedZipFile(imp: File64) {
        this.fileZip = imp;
    }
    isNotAvailableTs(value:boolean)
    {
        this.isAvailableTsfile =!value;
    }
    isNotAvailableJs(value:boolean)
    {
        this.isAvailableJsfile =!value;    
    }
    isNotAvailableZip(value:boolean)
    {
        this.isAvailableZipfile =!value;
    }
    pedirConfirmacion() {
        const modalRef = this.modalService.open(ConfirmacionModalComponent);

        const modalInstance = <ConfirmacionModalComponent>modalRef.componentInstance;
        const text = <string>this.translate.instant('DISABLE_TEXT');
        modalInstance.titulo = `${text} ${this.codviewEngine}`;

        modalRef.result
            .then(confirmacion => {
                this.viewEngineService.delete(this.codviewEngine).subscribe(c => {
                    this.alertService.showGrowl({
                        type: GrowlType.SUCCESS,
                        body: 'VIEW_ENGINE_DISABLE_MESSAGE',
                    }, { alias: this.codviewEngine });
                    this.back();
                });
            },
                reason => { /* Do nothing */ }
            );
    }

    zipOrDefault(){
        this.isZipFile = !this.isZipFile;
    }

    save() {
        const request = {
            component: this.viewEngine,
            jsFileName: null,
            jsFile: null,
            tsFileName: null,
            tsFile: null,
            zipFile: null,
            zipFileName: null
        };

        if (this.fileJs !== null) {
            request.jsFileName = this.fileJs.fileName;
            request.jsFile = this.fileJs.fileData;
            if (this.fileJs.fileName.indexOf(".umd") < 0) {
                this.errorCodigo = <string>this.translate.instant('VIEW_ENGINE_FILE_NAME_NOT_SUPPORTED');
                return;
            }
        }
        if (this.fileTs !== null) {
            request.tsFileName = this.fileTs.fileName;
            request.tsFile = this.fileTs.fileData;
        }
        if(this.fileZip !== null){
            request.zipFile = this.fileZip.fileData;
            request.zipFileName = this.fileZip.fileName;
        }

        this.viewEngineService.getByIdAndStatus(request.component.codViewEngine)
            .subscribe(res => {
                
                // Si el codigo ya existe, no puedo crear un viewEngine
                if (res !== null && this.esNuevo) {
                    this.errorCodigo = <string>this.translate.instant('VIEW_ENGINE_EXISTS');
                    return false;
                }

                this.viewEngineService.save(request, request.component.codViewEngine + ".umd").then(c => {
                    this.alertService.showGrowl({
                        type: GrowlType.SUCCESS,
                        body: 'VIEW_ENGINE_SUCCESS',
                    }, { alias: c.codViewEngine });

                    this.back();
                });
            });
    }

    validateVECode(){
        const regexInvalidReportCode = new RegExp('[^A-Z]+');
            if (regexInvalidReportCode.test(this.viewEngine.codViewEngine)) {
                this.viewEngineErrorCode = 'ViewEngine cannot have spaces or simbols or numbers';
                this.mostrarError = true;
                return false
            }
            else{
                this.viewEngineErrorCode = '';
                return true;
            }
    }

    isValidForm() {
        if(this.validateVECode()){
            return this.viewEngine.codViewEngine
            && this.viewEngine.description
            && this.viewEngine.moduleName
            && this.viewEngine.title
            && this.viewEngine.codViewEngine !== 'nuevo'
            && this.isAvailableTsfile 
            && this.isAvailableJsfile
            && (this.files.length > 0 || (this.fileJs !== null && this.fileTs !== null || this.fileZip !== null)); 
        }     
    }

    getFiles(codViewEngine: string) {
        this.viewEngineService.getFiles(codViewEngine).subscribe(f => this.files = f);
    }

    back() {
        this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
    }

    
  getOrganizations() {
    this.viewEngineService
      .getOrganizationList()
      .subscribe((res) => (this.viewEngine.categories = res.categories));
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/viewengine/edit/edit.viewengine.component.ts